import React from 'react'

import { Camera } from '@cinch/oxd-components/icons/src'

import * as styles from './image-count-lozenge.module.css'

interface ImageCountLozengeProps {
  totalImages: number
}

const CameraIcon = Camera

const ImageCountLozenge: React.FC<ImageCountLozengeProps> = ({ totalImages }) => {
  return (
    <div className={styles.imageCountLozenge}>
      <span className={styles.lozengeElement}>
        <div className={styles.cameraIcon}>
          <CameraIcon />
        </div>
        {totalImages}
      </span>
    </div>
  )
}

export default ImageCountLozenge
